module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_j_normal.9884b213.png";